import React, { type FC, useEffect } from "react";

import { inject, observer } from "mobx-react";
import { Toaster } from "sonner";

import { showToast } from "@ok/common/design-system/components/Toast/toastUtils";
import { Toast } from "@ok/common/design-system/components/Toast/BaseToast";

import type { IToastManagerInject } from "../../lib/types";
import { ToastAlert } from "@ok/common/design-system";

export interface IToastManagerProps extends IToastManagerInject {}

export const ToastManager: FC<IToastManagerProps> = inject('store', 'ctrl')(observer(({ store, ctrl }) => {
    const { attachToEventBuses, detachFromEventBuses } = ctrl!;
    const { toastQueue } = store!;

    useEffect(() => {
        attachToEventBuses();
        return () => detachFromEventBuses();
    }, [attachToEventBuses, detachFromEventBuses]);

    useEffect(() => {
        if (!toastQueue.length) return;

        store?.toastsToDisplay.forEach(toastItem => {
            if (toastItem.toastComponent) {
                showToast({
                    toastComponent: toastItem.toastComponent,
                    duration: toastItem.duration,
                    position: toastItem.position,
                });
            } else if (toastItem.type) {
                let content;
                switch (toastItem.type) {
                    case 'alert':
                        content = <ToastAlert preset={toastItem.preset} title={toastItem.title} />;
                        break;
                    case 'default':
                    default:
                        content = (
                            <Toast
                                title={toastItem.title}
                                subtitle={toastItem.subtitle}
                            />
                        );
                }
                showToast({
                    toastComponent: content,
                    duration: toastItem.duration,
                    position: toastItem.position,
                });
            } else if (toastItem.title) {
                showToast({
                    toastComponent: (
                        <Toast
                            title={toastItem.title}
                            subtitle={toastItem.subtitle}
                        />
                    ),
                    duration: toastItem.duration,
                    position: toastItem.position,
                });
            }
        });

        store?.clearProcessedToasts();
    }, [store, toastQueue.length]);

    return (
        <div>
            <Toaster />
        </div>
    );
}));
